import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { useProductResultsContext } from "../../../../../../context/productResults.context";

type StickyProps = RequireChildrenFor<{}>;

const Sticky = ({ children }: StickyProps) => {
    const { stickyFiltersRef } = useProductResultsContext();
    return (
        <div
            className={cn(
                "tw:grid-cols-[1fr_1fr] tw:gap-5 tw:top-0 tw:left-0 tw:bg-white tw:px-[1.4%]",
                "tw:layer-overlay/[0] tw:py-2 tw:border-b tw:border-b-grey-light tw:fixed",
                "tw:w-full tw:items-center tw:hidden"
            )}
            ref={stickyFiltersRef}
        >
            {children}
        </div>
    );
};

export { Sticky };
